(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sps-quiz"] && !Shopify.designMode) return;
  try {
    
if (!window.spsQuizInstalled) {
  window.spsQuizInstalled = true;
  let step = -1, answers = [], opener = null, emailSent = false, emailRequest = null, offerRequest = null;
  const root = () => document.querySelector('[data-sps-quiz-root]');
  const decode = s => String(s ?? '').replace(/&(?:#39|quot|amp|lt|gt|apos);/g, entity => ({'&#39;':"'",'&quot;':'"','&amp;':'&','&lt;':'<','&gt;':'>','&apos;':"'"}[entity]));
  const esc = s => decode(s).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const parse = selector => JSON.parse(root().querySelector(selector).textContent);
  const keys = {safety:'safety-boundaries-1',connection:'connection-without-compromise-1',money:'smart-money-logistics-1',first:'first-trip-confidence-1',chapter:'life-chapter-travel-1'};
  const options = [['new','further','regular','crossroads'],['safety','connection','money','first','chapter'],['gentle','abroad','celebrate','reset','people'],['overwhelmed','gaps','organised','stuck'],['safe','dining','money','arrival','boundaries','meaning','meeting'],['soon','year','someday'],['braver','prepared','inside','become']];
  const needHubs = {safe:'safety',dining:'connection',money:'money',arrival:'first',boundaries:'safety',meaning:'chapter',meeting:'connection'};
  const body = () => document.querySelector('[data-sps-inline-quiz]') || root()?.querySelector('[data-sps-quiz-body]');
  function recommendation(groups) {
    const group = groups.find(g => g.key === keys[answers[1]]);
    const supportTier = answers[3] === 'organised' ? 1 : answers[3] === 'overwhelmed' ? 3 : 2;
    const selectedHubs = [...new Set((answers[4] || []).map(a => keys[needHubs[a]]).filter(Boolean))];
    const broadNeeds = selectedHubs.length >= 3;
    const heroTier = answers[3] === 'organised' ? 1 : 2;
    const extraNeeds = selectedHubs.filter(key => key !== group?.key);
    const matchedExtras = extraNeeds.filter(key => group?.companions?.includes(key));
    return {group,supportTier,heroTier,broadNeeds,matchedExtras};
  }
  function endpoint(value) {
    if (!value) return null;
    try { const url = new URL(value,window.location.origin); return url.protocol === 'https:' ? url.href : null; } catch { return null; }
  }
  function canEmail(config) { return config.emailEnabled && endpoint(config.emailEndpoint); }
  function controls(c,multi=false) {
    return `<div class="sps-quiz-controls"><button type="button" class="sps-link" data-sps-back>${esc(c.back)}</button>${multi?`<button type="button" class="sps-button" data-sps-next${answers[4]?.length?'':' disabled'}>${esc(c.continue)} →</button>`:''}</div>`;
  }
  function resultHtml(c,groups,config) {
    const {group:g,supportTier,heroTier,broadNeeds,matchedExtras} = recommendation(groups);
    const p = g?.products[heroTier - 1];
    if (!p?.url) return `<h2 id="sps-quiz-title" tabindex="-1">${esc(c.empty)}</h2><a class="sps-link" href="${esc(config.catalogUrl)}">${esc(c.shop_systems)}</a><button type="button" class="sps-link" data-sps-restart>${esc(c.restart)}</button>`;
    const alt = (product,tier,label) => {
      if (!product?.url) return '';
      const fit = tier === 3 && (broadNeeds || supportTier === 3 || matchedExtras.length > 0);
      const guideList = String(product.guides || '').split('\n').filter(Boolean).map(x=>x.replace(/&amp;/g,'&'));
      const extraNames = matchedExtras.map(key=>groups.find(g=>g.key===key)?.title).filter(Boolean);
      return `<article class="${fit?'sps-depth-fit':''}"><p class="sps-eyebrow">${esc(label)}</p>${fit?`<p class="sps-compare-fit">${esc(broadNeeds?c.broad_fit:c.deeper_fit)}</p>`:''}${product.image?`<img class="sps-result-option-image" src="${esc(product.image)}" alt="${esc(product.title)}" width="600" height="600" loading="lazy">`:''}<h3>${esc(product.title)}</h3><p>${esc(product.fit)}</p><p><strong>${esc(product.price)}</strong> · ${esc(product.count)} ${esc(c.guides)}</p>${tier===3&&extraNames.length?`<p>${esc(c.extra_match)}: ${extraNames.map(esc).join(', ')}.</p>`:''}${guideList.length?`<details class="sps-preview"><summary>${esc(tier===3?c.includes:c.guides)}</summary><ul>${guideList.map(x=>`<li>${esc(x)}</li>`).join('')}</ul></details>`:''}<a class="sps-link" href="${esc(product.url)}">${esc(product.available?c.see_option:c.unavailable)} →</a></article>`;
    };
    const identityIndex = options[6].indexOf(answers[6]);
    return `<p class="sps-eyebrow">${esc(c.recommended)} · ${esc(g.title)}</p><h2 id="sps-quiz-title" tabindex="-1">${esc(p.title)}</h2><p>${esc(c['stage_'+answers[0]])} ${esc(p.fit)}</p><div class="sps-result-hero">${p.image?`<img class="sps-result-image" src="${esc(p.image)}" alt="${esc(p.title)}" width="600" height="600" loading="lazy">`:''}<div><p class="sps-price">${esc(p.price)}</p><p class="sps-note">${esc(p.count)} ${esc(c.guides)}</p><a class="sps-button" href="${esc(p.url)}">${esc(p.available?c.see_plan:c.unavailable)} ↗</a></div></div><div class="sps-result-personal"><p><strong>${esc(c.why)}</strong><br>${esc(c['why_'+answers[1]])} ${esc(c['style_'+answers[2]])}</p><p><strong>${esc(c.support)}</strong><br>${esc(c['support_'+answers[3]])}</p></div><div data-sps-offer></div><div class="sps-result-options">${heroTier===1?alt(g.products[1],2,c.upgrade):alt(g.products[0],1,c.lighter)}${alt(g.products[2],3,c.deeper)}</div><p class="sps-note">${esc(c.overlap)}</p><p class="sps-result-next"><strong>${esc(c.next_step)}</strong> ${esc(c['next_'+answers[5]])}</p><p class="sps-result-identity">${esc(c.identity)}<br>${esc(c['q7_'+String.fromCharCode(97+identityIndex)])}</p>${emailSent?`<p role="status">${esc(c.email_success)}</p>`:''}<div class="sps-result-actions"><a class="sps-link" href="${esc(g.url)}">${esc(c.compare)}</a><button type="button" class="sps-link" data-sps-back>${esc(c.back)}</button><button type="button" class="sps-link" data-sps-restart>${esc(c.restart)}</button></div>`;
  }
  function draw(focus=true) {
    if (!root()) return;
    const c = parse('[data-sps-quiz-copy]'),groups=parse('[data-sps-quiz-products]'),config=parse('[data-sps-quiz-config]');
    const b=body(); if(!b)return;
    const inline=document.querySelector('[data-sps-inline-quiz]');
    if(inline)inline.hidden=false;
    if(step === -1) {
      b.innerHTML=`<div class="sps-quiz-cover"><p class="sps-eyebrow">${esc(c.cover_eyebrow)}</p><h2 id="sps-quiz-title" tabindex="-1">${esc(c.cover_title)}</h2><p class="sps-quiz-cover-copy">${esc(c.cover_subtitle)}</p><button type="button" class="sps-button" data-sps-begin>${esc(c.cover_button)} →</button><p class="sps-note">${esc(c.no_email)}</p></div>`;
    } else if(step<7) {
      const n=step+1, prefix='q'+n+'_';
      const choices=options[step].map((value,i)=>({value,label:c[prefix+String.fromCharCode(97+i)]}));
      const content=step===4?`<fieldset class="sps-multi" aria-labelledby="sps-quiz-title"><legend>${esc(c.choose)}</legend>${choices.map(o=>`<label><input type="checkbox" data-sps-multi value="${o.value}"${answers[4]?.includes(o.value)?' checked':''}><span>${esc(o.label)}</span></label>`).join('')}</fieldset><p class="sps-note" data-sps-selection-count aria-live="polite">${answers[4]?.length||0} ${esc(c.selected)}</p>`:`<div class="sps-answers">${choices.map(o=>`<button type="button" data-sps-answer="${o.value}" aria-pressed="${answers[step]===o.value}">${esc(o.label)} <span aria-hidden="true">${answers[step]===o.value?'✓':'→'}</span></button>`).join('')}</div>`;
      b.innerHTML=`<div class="sps-quiz-category"><p class="sps-eyebrow">${esc(c[prefix+'label'])}</p><span>${esc(c.question)} ${n} ${esc(c.of)} 7</span></div><progress value="${n}" max="7" aria-label="${esc(c.question)} ${n} ${esc(c.of)} 7"></progress><h2 id="sps-quiz-title" tabindex="-1">${esc(c[prefix+'question'])}</h2><p>${esc(c[prefix+'helper'])}</p>${content}${controls(c,step===4)}`;
    } else if(step===7 && canEmail(config)) {
      b.innerHTML=`<p class="sps-eyebrow">${esc(c.result)}</p><h2 id="sps-quiz-title" tabindex="-1">${esc(c.email_title)}</h2><form class="sps-email-form" data-sps-email-form><label for="sps-result-email">${esc(c.email_label)}</label><input id="sps-result-email" type="email" name="email" autocomplete="email" required maxlength="254"><button type="submit" class="sps-button">${esc(c.email_send)}</button><p class="sps-email-status" role="status" data-sps-email-status></p></form><button type="button" class="sps-link" data-sps-skip-email>${esc(c.email_skip)}</button><p class="sps-note">${esc(c.email_note)}</p>${controls(c)}`;
    } else {
      b.innerHTML=resultHtml(c,groups,config);
      if(config.offerEnabled && endpoint(config.offerEndpoint))loadOffer(c,groups,config);
    }
    if(focus){b.scrollIntoView({block:'start'});b.querySelector('#sps-quiz-title')?.focus({preventScroll:true});}
  }
  function openQuiz(button) {
    opener=button;
    const inline=document.querySelector('[data-sps-inline-quiz]');
    if(inline){document.querySelector('[data-sps-quiz-cover]')?.setAttribute('hidden','');if(step===-1)step=0;draw();}
    else{draw(false);root().querySelector('dialog').showModal();body().querySelector('#sps-quiz-title')?.focus();}
  }
  function resultPayload(groups) {
    const {group,supportTier,heroTier,broadNeeds}=recommendation(groups);
    return {quizVersion:'sps-seven-questions-v2',answers:answers.slice(),system:group?.key,supportTier,heroTier,broadNeeds,product:group?.products[heroTier - 1]?.url};
  }
  async function sendEmail(form) {
    const c=parse('[data-sps-quiz-copy]'),config=parse('[data-sps-quiz-config]');
    if(!canEmail(config)||!form.reportValidity())return;
    const submit=form.querySelector('button[type="submit"]'),status=form.querySelector('[data-sps-email-status]');
    submit.disabled=true;submit.textContent=c.email_sending;
    emailRequest?.abort();const request=new AbortController();emailRequest=request;
    const timeout=setTimeout(()=>request.abort(),12000);
    try {
      const response=await fetch(endpoint(config.emailEndpoint),{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',signal:request.signal,body:JSON.stringify({...resultPayload(parse('[data-sps-quiz-products]')),email:form.elements.email.value.trim(),marketingConsent:false})});
      if(!response.ok)throw new Error('delivery');const result=await response.json();if(result.accepted!==true)throw new Error('delivery');
      if(step===7 && emailRequest===request){emailSent=true;step=8;draw();}
    }catch{if(step===7 && emailRequest===request){status.textContent=c.email_error;submit.disabled=false;submit.textContent=c.email_send;}}
    finally{clearTimeout(timeout);}
  }
  async function loadOffer(c,groups,config) {
    const slot=body()?.querySelector('[data-sps-offer]');if(!slot)return;
    offerRequest?.abort();const request=new AbortController();offerRequest=request;
    const timeout=setTimeout(()=>request.abort(),10000);
    try {
      let sessionId;
      try{sessionId=sessionStorage.getItem('sps-quiz-offer-session');if(!sessionId){sessionId=crypto.randomUUID();sessionStorage.setItem('sps-quiz-offer-session',sessionId);}}catch{return;}
      const response=await fetch(endpoint(config.offerEndpoint),{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',signal:request.signal,body:JSON.stringify({...resultPayload(groups),sessionId})});
      if(!response.ok)return;const offer=await response.json();
      const expiry=Date.parse(offer.expiresAt),issued=Date.parse(offer.issuedAt),now=Date.now();
      const valid=typeof offer.code==='string' && offer.code.length>0 && offer.code.length<=64 && typeof offer.label==='string' && expiry>now && issued<=now && expiry-issued<=48*60*60*1000 && expiry>issued;
      if(!valid||!slot.isConnected||offerRequest!==request)return;
      const result=recommendation(groups);const product=result.group?.products[result.heroTier - 1];if(!product?.url)return;
      if(typeof offer.termsUrl!=='string'||!offer.termsUrl)return;const terms=new URL(offer.termsUrl,window.location.origin);if(terms.origin!==window.location.origin)return;
      const link='/discount/'+encodeURIComponent(offer.code)+'?redirect='+encodeURIComponent(product.url);
      slot.innerHTML=`<aside class="sps-quiz-offer"><p class="sps-eyebrow">${esc(c.offer_heading)}</p><h3>${esc(offer.label)}</h3><p>${esc(c.offer_until)} <time datetime="${esc(offer.expiresAt)}">${esc(new Date(expiry).toLocaleString())}</time></p><a class="sps-button" href="${esc(link)}">${esc(c.offer_apply)} →</a><p class="sps-note"><a href="${esc(terms.href)}">${esc(c.offer_terms)}</a> · ${esc(c.offer_note)}</p></aside>`;
      setTimeout(()=>{if(slot.isConnected)slot.replaceChildren();},Math.min(expiry-now,2147483647));
    }catch{}finally{clearTimeout(timeout);}
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('button');if(!button||!root())return;
    if(button.hasAttribute('data-sps-quiz'))openQuiz(button);
    else if(button.hasAttribute('data-sps-begin')){step=0;draw();}
    else if(button.hasAttribute('data-sps-answer') && step>=0 && step<7 && step!==4){const value=button.dataset.spsAnswer;if(options[step].includes(value)){emailSent=false;answers[step]=value;step++;draw();}}
    else if(button.hasAttribute('data-sps-next') && step===4 && answers[4]?.length){step++;draw();}
    else if(button.hasAttribute('data-sps-back')){emailRequest?.abort();offerRequest?.abort();step=step>=7?6:Math.max(-1,step-1);draw();}
    else if(button.hasAttribute('data-sps-skip-email')){emailRequest?.abort();step=8;draw();}
    else if(button.hasAttribute('data-sps-restart')){emailRequest?.abort();offerRequest?.abort();step=-1;answers=[];emailSent=false;draw();}
    else if(button.hasAttribute('data-sps-close')){root().querySelector('dialog').close();opener?.focus();}
  });
  document.addEventListener('change',e=>{
    const input=e.target;if(!input.matches('[data-sps-multi]')||step!==4||!options[4].includes(input.value))return;
    const selected=new Set(answers[4]||[]);if(input.checked)selected.add(input.value);else selected.delete(input.value);answers[4]=[...selected];emailSent=false;
    const b=body(),c=parse('[data-sps-quiz-copy]');b.querySelector('[data-sps-next]').disabled=!selected.size;b.querySelector('[data-sps-selection-count]').textContent=selected.size+' '+c.selected;
  });
  document.addEventListener('submit',e=>{if(e.target.matches('[data-sps-email-form]')){e.preventDefault();sendEmail(e.target);}});
  document.addEventListener('shopify:section:load',()=>{root()?.querySelector('dialog')?.close();if(step>=0 && document.querySelector('[data-sps-inline-quiz]')){document.querySelector('[data-sps-quiz-cover]')?.setAttribute('hidden','');draw(false);}});
}


  } catch(e) { console.error(e); }
})();
})();
